const localJcnd='2021';
  export default
  {
    localJcnd//前端本地 提交监测年度，适用于 提报数据里面的jcnd
  }